import React, {useState, useEffect} from 'react';
import PaymentsListSection from './PaymentsListSection';
import SpeiInfoModal from '../shared/SpeiInfoModal';
import PackagesBoughtInfoListSection from './PackagesBoughtInfoListSection';
import {useTranslation} from "react-i18next";

import {httpGet} from '../shared/Config';

function Payments() {

    const [showSpeiInfo, setShowSpeiInfo] = useState(false)
    const {t} = useTranslation();
    
    const [allowPurchases, setAllowPurchases] = useState(false);
    const [checkDone, setCheckDone] = useState(false);
    
    const [currency, setCurrency] = useState("");
    const [ivaIncluded, setIvaIncluded] = useState(true);

    async function fetchServerConf() {
        try {
            const response = await httpGet('/getServerConf');
            if(response?.data.jsonData) {
                let parseConf = JSON.parse(response.data.jsonData);
                const responseAllow = await httpGet('/allowPurchases');
                if(parseConf.purchaseActive && responseAllow.data.allow) {
                    setAllowPurchases(true);    
                }
                setCheckDone(true);
            }
        } catch(e) {
            console.error(e);
        }
    }

    useEffect(() => {
        fetchServerConf();
    }, [])

    return (
        <div>
            <div className={'prose'}>
                <h3>                                        
                    {
                        checkDone && allowPurchases ? <span>{t('PAYMENT_INFO')}</span> : <span>{t('PACKAGES_INFO')}</span>
                    }
                </h3>
            </div>
            <br/>
            {
                checkDone && allowPurchases ? <React.Fragment>
                    <PaymentsListSection
                        hideIfNoData={true}
                        title={t('Pending transfers (SPEI)')}
                        desc={
                        <div className={'prose'}>
                            <p>
                                {t('Please make the transfer before the deadline to continue using the service')}
                            </p>
                            <button className={'btn btn-outline ml-5'}  onClick={() => setShowSpeiInfo(true)}>
                                {t('More information')}
                            </button>
                        </div>
                        }
                        status="PENDING_SPEI"
                        typeString="'Pendientes de SPEI'" />
                    <PaymentsListSection
                        hideIfNoData={true}
                        title={t('PURCHASE_HISTORY')}
                        status="COMPLETED"
                        typeString="'Completadas'" />
                    <SpeiInfoModal
                        isOpen={showSpeiInfo}
                        onClose={() => setShowSpeiInfo(false)}></SpeiInfoModal>
                </React.Fragment> : null
            }
            
            <PackagesBoughtInfoListSection
                hideIfNoData={true}
                title={t('Bought packs')}
                desc={
                    <div className={'prose'}>
                        <p>
                            {t('Bought packs description')}
                        </p>
                    </div>
                }
                status="Todos"
                typeString="todos" />
        </div>
    )
}

export default Payments;
